import { ACCESS_LIST, ORG_LIST } from "../statics/localStorage";

export function accessCodeToAccessName(accessCode) {
    if (accessCode) {
        const access = ACCESS_LIST().find(item => item?.code === accessCode);
        return access?._id ? access : null;
    }
    return null;
}

export function accessCodeArrayToAccessGroup(accessCodeArray) {
    if (accessCodeArray && accessCodeArray.length > 0) {
        const sortedArray = (accessCodeArray?.map(accessCode => accessCodeToAccessName(accessCode))?.sort((a, b) => a.order - b.order))
        return sortedArray.reduce((acc, code) => {
            acc[code.group] = acc[code.group] || [];
            acc[code.group].push(code);
            return acc;
        }, {});
    }
    return [];
}

export function statusCodeToStatusDetails(statusCode) {
    const statusCodesData = [
        {
            code: 0,
            name: 'UNSPECIFIED',
            color: '#FABC05',
            accentColor: '#FABC0520'
        }, {
            code: 1,
            name: 'UNKNOWN',
            color: '#007bff',
            accentColor: '#007bff20'
        }, {
            code: 2,
            name: 'ENABLED',
            color: '#15BC00',
            accentColor: '#15BC0020'
        }, {
            code: 3,
            name: 'PAUSED',
            color: '#DC3545',
            accentColor: '#DC354520'
        }, {
            code: 4,
            name: 'REMOVED',
            color: '#6c757d',
            accentColor: '#6c757d20'
        }
    ];

    return statusCodesData.find(status => status.code === statusCode);
}

export function getOrgNameFromOrgId(orgId) {
    const orgList = ORG_LIST();
    const org = orgList?.find(org => org?.organizationId === orgId);
    return org?._id ? org.name : '';
}

export function camelToNormal(text) {
    return text
        .replace(/([A-Z])/g, ' $1')  // Add space before capital letters
        .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
        .trim(); // Remove leading space if any
}